import { useSelector } from 'react-redux'
import { selectAnswers } from 'root-redux/selects/common'
import { OptionValue, StressLevel, StressValue } from 'root-constants'

export const useStressLevelPoints = (): StressValue => {
  const answers = useSelector(selectAnswers)
  const stressfulAnswerNumber = Object.values(answers || []).filter(
    (answer) =>
      answer === OptionValue.OFTEN || answer === OptionValue.VERY_MUCH_SO,
  ).length

  if (stressfulAnswerNumber >= StressLevel.RED_LEVEL) {
    return StressValue.SEVERE
  }

  if (
    stressfulAnswerNumber > StressLevel.BLUE_LEVEL &&
    stressfulAnswerNumber <= StressLevel.ORANGE_LEVEL
  ) {
    return StressValue.MODERATE
  }

  return StressValue.LOW
}
